module.exports = __webpack_public_path__ + "static/nas.ac193734.png";